import { eventPartOfSeriesShortString } from './PeekEventContent.locstring.json';
import { observer } from 'mobx-react-lite';
import { Icon } from '@fluentui/react/lib/Icon';
import DataRow from 'owa-calendar-forms-common/lib/components/DataRow';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { ControlIcons } from 'owa-control-icons';
import loc from 'owa-localize';
import { eventDateAccessibility } from 'owa-locstrings/lib/strings/eventdateaccessibility.locstring.json';
import formatMeetingTimeSpan from 'owa-timeformat/lib/utils/formatMeetingTimeSpan';
import * as React from 'react';
import { TimeProposalsStub } from 'owa-calendar-forms-common/lib/components/componentStubs';

const styles = require('./CalendarItemPeek.scss');

interface PeekEventTimeRowProps {
    item: CalendarEvent;
    onReviewProposedNewTimeClicked?: (event?: Partial<CalendarEvent>) => void;
}

export default observer(function PeekEventTimeRow(props: PeekEventTimeRowProps) {
    const { item, onReviewProposedNewTimeClicked } = props;

    return (
        <DataRow
            className={styles.timeRow}
            iconName={ControlIcons.Clock}
            iconClassName={styles.whenIcon}>
            <div className={styles.timeDataValue}>
                <span aria-label={loc(eventDateAccessibility)} className={styles.eventDate}>
                    {formatMeetingTimeSpan(item.Start, item.End, item.Recurrence)}
                </span>
                {item.IsRecurring && (
                    <div className={styles.partOfSeriesText}>
                        <span>{loc(eventPartOfSeriesShortString)}</span>
                        <Icon
                            iconName={ControlIcons.SyncOccurence}
                            styles={{
                                root: {
                                    fontSize: '14px',
                                    marginTop: '1px',
                                    marginLeft: '4px',
                                    userSelect: 'none',
                                },
                            }}
                        />
                    </div>
                )}
                {item.IsOrganizer && onReviewProposedNewTimeClicked && (
                    <TimeProposalsStub
                        event={item}
                        onReviewClicked={onReviewProposedNewTimeClicked}
                        hideTime={true}
                        className={styles.timeProposals}
                    />
                )}
            </div>
        </DataRow>
    );
});
